import { IBICResolverResult, ICIBResolutionContext } from '../types'

export const resolveIBICNoneRule = ({ previousResult, task, allTasks, tasksPerDay }: ICIBResolutionContext): IBICResolverResult => {
  return null
}
